export const WhatNextData = [
  {
    subtitle:
      'Ознакомьтесь с точными условиями от банка и выберите подходящее предложение. Кредит\u00A0уже\u00A0одобрен банком',
  },
  {
    subtitle: 'Ожидайте звонка и дальнейших шагов от выбранного банка',
  },
  {
    subtitle: 'Выберите способ получения кредита',
  },
  {
    subtitle: 'Банк проверит ваши документы и анкетные данные',
  },
  {
    subtitle: 'Получите кредит от банка',
  },
];

export const WhatNextDataWithStatus = [
  {
    title: 'Дождитесь звонка сотрудника банка',
    subtitle: 'Чтобы обсудить подробности вашей заявки и необходимые документы',
  },
  {
    title: 'Оформите кредит в офисе банка',
    subtitle: 'Вы можете выбрать удобный для вас офис на карте',
  },
];

export const WhatNextDataWithoutStatus = [
  {
    title: 'Оставьте заявку на Сравни',
    subtitle: 'Чтобы повысить вероятность одобрения, отправьте заявку в несколько банков',
  },
  {
    title: 'Дождитесь решения от банка',
    subtitle: 'С вами свяжется сотрудник банка, чтобы обсудить подробности вашей заявки и необходимые документы',
  },
  {
    title: 'Оформите кредит в отделении банка',
    subtitle: 'Вы можете выбрать удобный для вас офис на карте',
  },
];
